import ResponseErrorTypes from './ResponseErrorTypes';

// Error Types UI team created for the Error Page (can contain same name as ResponseErrorTypes)
const ErrorPageErrorTypes = Object.freeze({
    GENERIC_ERROR: 'GENERIC_ERROR',
    FAILED_TO_LOAD: 'FAILED_TO_LOAD',
    EMAIL_VERIFICATION_EXPIRED: 'EMAIL_VERIFICATION_EXPIRED',
    VEEVAID_REGISTRATION_LINK_INVALID: ResponseErrorTypes.VEEVAID_REGISTRATION_LINK_INVALID,
    VEEVAID_INVALID_PASSWORD_RESET_LINK: ResponseErrorTypes.VEEVAID_INVALID_PASSWORD_RESET_LINK,
});

export default ErrorPageErrorTypes;
